import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 380;

export const useStyles = makeStyles(
  (theme) => (
    {
      appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      menuButton: {
        marginRight: 36,
      },
      hide: {
        display: 'none',
      },
      menuButtonCloseProcess: {
        marginRight: theme.spacing(6),
        padding: '0px 10px',
      },
    }
  )
);

export default useStyles;
